'use client'

/***
 *
 * @file components/Spinner/index.tsx
 * @description Spinner component will be used for rendering the content.
 * @author Naveen Kumar
 * @organization Truminds Software System
 * @since 13 Feb 2024
 *
 */

import React, { ReactNode, useEffect, useState } from "react";
// import "./Spinner.scss";
import classNames from "classnames";

type Props = {
  children?: ReactNode,
  loading?: boolean,
  loadingText?: string,
  style?: any;
  timer?: number;
  skipTimer?: boolean;
  fullPage?: boolean;
  className?: string,
}

const Spinner = ({ children, loading = false, loadingText = "", style = {}, timer = 1000, skipTimer=false, fullPage=true, className="!bg-spinner-page spinner-bg" }: Props) => {
  const [showSpinner, setShowSpiner] = useState(true);
  const [delayChildren, setDelayChildren] = useState(true);

  useEffect(() => {
    setShowSpiner(loading);

    if(!skipTimer) {
      setTimeout(() => {
        setShowSpiner(false);
      }, timer);
    }
    setTimeout(() => { setDelayChildren(false) }, 300 );
  }, [loading, timer])
  return (
    <div className={classNames("Spinner-container", { "Spinner-absolute": !fullPage})} data-testid="Spinner" suppressHydrationWarning>
      {showSpinner &&
        <div className={classNames("spinner-content", className)} style={{ position: fullPage ? 'fixed' : 'absolute', ...style }} suppressHydrationWarning>
          <div className="spinner" suppressHydrationWarning>
            {/* {showSpinner ? <div className={'spinner'}></div> : children} */}
            <div className={'spinning !border-spinner-edge'} suppressHydrationWarning></div>
            {loadingText && <div style={{ paddingTop: "10px", textAlign: "center" }} className="!text-spinner-label" suppressHydrationWarning>{loadingText}</div>}
          </div>
        </div>
      }
      {children}
    </div>
  );
};

export default Spinner;
